<section class="logged-out">
  <div class="logged-out-box">
    <h1 class="title">{{ boxText | translate }}</h1>

    <div class="action" [ngClass]="{'hide': hideButton}">
      <ng-content></ng-content>
    </div>
  </div>
</section>
